// CommonJS so gatsby-node can require it while the React components import it
// through the @config alias.

// Editors enter durations in the CMS as an ISO 8601 duration without the
// leading "PT" - e.g. "12M4S". Anything that doesn't match that shape is
// discarded rather than emitted as broken structured data.
const DURATION_PATTERN = /^(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/

const getVideoEmbedUrl = ({ provider, providerUid, url } = {}) => {
  switch (provider) {
    case "youtube":
      return `https://www.youtube.com/embed/${providerUid}?rel=0`
    case "vimeo":
      return `https://player.vimeo.com/video/${providerUid}`
    case "facebook":
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
        url
      )}`
    default:
      return url
  }
}

const parseDuration = duration => {
  if (!duration) return null

  const match = duration.trim().match(DURATION_PATTERN)

  if (!match || !match[0]) return null

  const [, hours, minutes, seconds] = match

  return {
    hours: Number(hours || 0),
    minutes: Number(minutes || 0),
    seconds: Number(seconds || 0)
  }
}

const getIsoDuration = duration =>
  parseDuration(duration) ? `PT${duration.trim()}` : null

const getDurationInSeconds = duration => {
  const parsed = parseDuration(duration)

  if (!parsed) return null

  return parsed.hours * 3600 + parsed.minutes * 60 + parsed.seconds
}

module.exports = {
  getVideoEmbedUrl,
  getIsoDuration,
  getDurationInSeconds
}
